
import { Observable, Subscriber } from 'rxjs';


import { Firestore, collection, query, collectionData, where, limit,
   startAfter, CollectionReference, Query, startAt, getDocs, QueryConstraintType, QueryFieldFilterConstraint, DocumentSnapshot, QueryConstraint, QueryCompositeFilterConstraint,
   DocumentData} from '@angular/fire/firestore';

export class FirebasePaged {

  private  resultSubscriber: Subscriber<any>;


  private lastDoc: DocumentSnapshot;



  private finalQuery: Query;
  constructor(private docCol: Query<DocumentData>, private constraints: QueryConstraint[], private l: number) {



  }

  observe(): Observable<any>{
     let observable = new Observable((observer) => {
        this.resultSubscriber = observer;
        //this.refresh();
     });

     return observable;
  }

  /*refresh(){



    let finalQ = query(this.docCol, ...this.constraints , limit(this.l));

    if(this.lastDoc != undefined && this.lastDoc != null){
      finalQ = query(this.docCol, ...this.constraints , limit(this.l), startAfter(this.lastDoc));
    }
    getDocs(finalQ).then(qs => {
      this.lastDoc = qs.docs[qs.docs.length - 1];

      this.resultSubscriber.next(qs.docs.map(qd => {
       var data = qd.data();
        data.id = qd.id;
       return data;

    }));
    });



  }*/

  refresh() {
    // Verificar si el último documento está disponible antes de continuar
    let finalQ = query(this.docCol, ...this.constraints , limit(this.l));
  
    if (this.lastDoc !== undefined && this.lastDoc !== null) {
      finalQ = query(this.docCol, ...this.constraints , limit(this.l), startAfter(this.lastDoc));
    }
  
    getDocs(finalQ).then(qs => {
      this.lastDoc = qs.docs[qs.docs.length - 1];
      const resultados = qs.docs.map(qd => {
        const data = qd.data();
        data.id = qd.id;
        return data;
      });
  
      console.log("Resultados crudos:", resultados);
      this.resultSubscriber.next(resultados); // Emite solo nuevos resultados
    });
  }
  
  
  reset() {
    this.lastDoc = null;
  }

};

